// import { useEffect, useRef } from "react";
// import styles from "../../../pages/superadmin/Receipts.module.css";

// const OptionsMenu = ({
//   mode,
//   index,
//   closeMenu,
//   openCancelReceiptModal,
//   receiptData,
//   openUpdateModal,
//   openInfoModal,
//   openRefundModal,
//   openReceiptModal,
// }) => {
//   const menuRef = useRef(null);
//   useEffect(() => {
//     const handleOutsideClick = (event) => {
//       if (menuRef.current && !menuRef.current.contains(event.target)) {
//         closeMenu();
//       }
//     };

//     document.addEventListener("mousedown", handleOutsideClick);
//     return () => {
//       document.removeEventListener("mousedown", handleOutsideClick);
//     };
//   }, [closeMenu]);

//   // //console.log("___>>> ", receiptData);

//   const handleClick = (e, arg) => {
//     e.stopPropagation();
//     if (arg === "cancel") {
//       if (
//         receiptData.status === "Cancelled" ||
//         receiptData.status === "Refund"
//       ) {
//         openInfoModal(receiptData.status);
//       } else {
//         openCancelReceiptModal(receiptData);
//       }
//     }
//     if (arg === "update") {
//       if (
//         receiptData.status === "Cancelled" ||
//         receiptData.status === "Refund" ||
//         receiptData.status === "Received"
//       ) {
//         openInfoModal(receiptData.status);
//       } else {
//         openUpdateModal(receiptData);
//       }
//     }
//     if (arg === "refund") {
//       // console.log("asass");
//       if (
//         receiptData.status === "Cancelled" ||
//         receiptData.status === "Refund" ||
//         (receiptData.status.includes("Pending") &&
//           receiptData.status !== "Pending For Refund")
//       ) {
//         openInfoModal(receiptData.status);
//       } else {
//         if (
//           receiptData.status === "Received" ||
//           receiptData.status === "Pending For Refund"
//         ) {
//           openRefundModal(receiptData);
//         }
//       }
//     }
//     if (arg === "click") {
//       if (
//         receiptData.status === "Refund" ||
//         receiptData.status === "Pending For Refund"
//       ) {
//         // console.log("open receipt modal ");
//         openReceiptModal(
//           receiptData.receiptId,
//           receiptData.orderId,
//           "click",
//           receiptData.reason
//         );
//       }
//     }
//     closeMenu();
//   };
//   // console.log(receiptData.status);
//   return (
//     <ul
//       ref={menuRef}
//       key={index}
//       className={`${styles.options_menu} ${
//         mode ? styles.options_menu_dark : ""
//       }`}
//       style={
//         index === 0
//           ? { right: "1rem", top: "0px" }
//           : index === 14
//           ? { right: "1rem", bottom: "0%" }
//           : { right: "1rem" }
//       }
//     >
//       <li
//         className={`${styles.options_menu_li} ${
//           mode ? styles.options_menu_li_dark : ""
//         }`}
//         onClick={(e) => handleClick(e, "cancel")}
//       >
//         Cancel
//       </li>
//       <li
//         className={`${styles.options_menu_li} ${
//           mode ? styles.options_menu_li_dark : ""
//         }`}
//         onClick={(e) => handleClick(e, "update")}
//       >
//         Update
//       </li>
//       <li
//         className={`${styles.options_menu_li} ${
//           mode ? styles.options_menu_li_dark : ""
//         }`}
//         onClick={(e) => {
//           if (
//             receiptData.status === "Refund" ||
//             receiptData.status === "Pending For Refund"
//           ) {
//             // console.log("if");
//             handleClick(e, "click");
//           } else {
//             // console.log("else");
//             handleClick(e, "refund");
//           }
//         }}
//       >
//         {receiptData.status === "Refund" ||
//         receiptData.status === "Pending For Refund"
//           ? "View"
//           : "Refund"}
//       </li>
//     </ul>
//   );
// };

// export default OptionsMenu;

import { useEffect, useRef } from "react";
import styles from "../../../pages/superadmin/Receipts.module.css";

const OptionsMenu = ({
  mode,
  index,
  closeMenu,
  openCancelReceiptModal,
  receiptData,
  openUpdateModal,
  openInfoModal,
  openRefundModal,
  openReceiptModal,
}) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        closeMenu();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [closeMenu]);

  const isCancelable = () =>
    ["Cancelled", "Refund"].includes(receiptData.status);

  const isUpdatable = () =>
    ["Cancelled", "Refund", "Received"].includes(receiptData.status);

  const isRefundable = () =>
    !isCancelable() &&
    !receiptData.status.includes("Pending") &&
    receiptData.status !== "Received" &&
    receiptData.status === "Pending For Refund";

  const handleAction = (e, actionType) => {
    e.stopPropagation();

    const actions = {
      cancel: () =>
        isCancelable()
          ? openInfoModal(receiptData.status)
          : openCancelReceiptModal(receiptData),
      update: () =>
        isUpdatable()
          ? openInfoModal(receiptData.status)
          : openUpdateModal(receiptData),
      refund: () => {
        if (["Refund", "Pending For Refund"].includes(receiptData.status)) {
          openReceiptModal(
            receiptData.receiptId,
            receiptData.orderId,
            "click",
            receiptData.reason
          );
        } else if (isRefundable()) {
          openRefundModal(receiptData);
        } else {
          openInfoModal(receiptData.status);
        }
      },
    };

    if (actions[actionType]) {
      actions[actionType]();
    }

    closeMenu();
  };

  // console.log(isRefundable);

  return (
    <ul
      ref={menuRef}
      key={index}
      className={`${styles.options_menu} ${
        mode ? styles.options_menu_dark : ""
      }`}
      style={
        index === 0
          ? { right: "1rem", top: "0px" }
          : index === 14
          ? { right: "1rem", bottom: "0%" }
          : { right: "1rem" }
      }
    >
      <li
        className={`${styles.options_menu_li} ${
          mode ? styles.options_menu_li_dark : ""
        }`}
        onClick={(e) => handleAction(e, "cancel")}
      >
        Cancel
      </li>
      <li
        className={`${styles.options_menu_li} ${
          mode ? styles.options_menu_li_dark : ""
        }`}
        onClick={(e) => handleAction(e, "update")}
      >
        Update
      </li>
      <li
        className={`${styles.options_menu_li} ${
          mode ? styles.options_menu_li_dark : ""
        }`}
        onClick={(e) => handleAction(e, "refund")}
      >
        {["Refund", "Pending For Refund"].includes(receiptData.status)
          ? "View"
          : "Refund"}
      </li>
    </ul>
  );
};

export default OptionsMenu;
